import { getPlace as publicGetPlace } from './atlas-v2-place-places.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getPlace: MaybeContext<
  BuildRESTFunction<typeof publicGetPlace> & typeof publicGetPlace
> = /*#__PURE__*/ createRESTModule(publicGetPlace);

export { SubdivisionType } from './atlas-v2-place-places.universal.js';
export {
  Place,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  GetPlaceRequest,
  GetPlaceResponse,
  GetPlaceOptions,
} from './atlas-v2-place-places.universal.js';
export { SubdivisionTypeWithLiterals } from './atlas-v2-place-places.universal.js';
